import { PlotContainer } from '../../../plot/components/PlotContainer';
import { Column } from '../../../plot/contexts/column.context';
import { Plot } from '../../../plot/contexts/plot.context';
import { Row } from '../../../plot/contexts/row.context';
import { Strip } from '../../../plot/contexts/strip.context';
import { squareToPixel } from '../../../plot/utils/graph.utils';
import { StripContent } from '../../../plot/components/StripContent';
import { Scale } from '../../../plot/types/scale';
import { ClusterYAxis } from './ClusterYAxis';
import { ClusterXAxis } from './ClusterXAxis';
import { useOnResizeValue } from '../../../../shared/hooks/useOnResizedValue';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  yScale: Scale;
  xScale: Scale;
  duration: number;
  xLabel?: string;
  yLabel?: string;
}>;

const PLOT_FOOTER_HEIGHT = squareToPixel(2);
export const PLOT_HEIGHT_PERCENTAGE = 0.3;
export const PLOT_WIDTH_PERCENTAGE = 0.3;
const AXIS_WIDTH = squareToPixel(1);
const OFFSET_LEFT = squareToPixel(1.1);

export const ClusterPlotContainer: React.FC<Props> = ({
  children,
  xScale,
  yScale,
  duration,
  xLabel,
  yLabel,
}) => {
  const height = useOnResizeValue(
    () => window.innerHeight * PLOT_HEIGHT_PERCENTAGE,
  );
  const width = useOnResizeValue(
    () => window.innerWidth * PLOT_WIDTH_PERCENTAGE,
  );
  const offset = useOnResizeValue(() => window.innerHeight * 0.05);
  return (
    <PlotContainer
      pt='s'
      pb={xLabel ? 0 : 'xs'}
      pr='m'
      width={width}
      height={height * 1.05}
    >
      <Strip id='cluster-plot' duration={duration}>
        <Plot>
          <Row height={height} topOffset={5}>
            <Column width={AXIS_WIDTH} offsetLeft={yLabel ? OFFSET_LEFT : 0}>
              <ClusterYAxis scale={yScale} label={yLabel} />
            </Column>
            <Column width={width}>
              <StripContent>{children}</StripContent>
            </Column>
          </Row>
          <Row height={PLOT_FOOTER_HEIGHT}>
            <Column
              width={squareToPixel(1)}
              offsetLeft={xLabel ? OFFSET_LEFT : 0}
            />
            <Column width={width}>
              <ClusterXAxis scale={xScale} label={xLabel} offset={offset} />
            </Column>
          </Row>
        </Plot>
      </Strip>
    </PlotContainer>
  );
};
